module.exports = __webpack_public_path__ + "media/thanos_dust_4.adf013fc.mp3";